export default `
1948
@
במדינת ישראל הצעירה יש כ-5,600 מכוניות פרטיות, 7,900 מסחריות, 1,100 מוניות, 800 אוטובוסים ו-4,500 אופנועים. כבישים? 2,600 ק"מ אבל רק 1,200 ק"מ מהם סלולים. הכבישים הראשיים: חיפה-ת"א, חיפה-נצרת, צמח-עפולה
@
1949
@
תגידו מזל טוב ללוחית רישוי ציונית ראשונה: עד ארבע ספרות, בצירוף אותיות, לפי אזורי רישום. ים' זה ירושלים, ת' זו תל אביב ויש גם כ' לכרמל וצ' לצה"ל ומ' למשטרה. לוחיות אוטובוסים ומוניות – בירוק. יש גם רמזור ראשון תלוי על חוט, בצומת הרחובות הרצל, ביאליק ובלפור בחיפה. ושמו בישראל: "מנגנון אור אוטומטי לכיוון תנועה"
@
1950
@
מכוניות וולוו שוודיות ראשונות מגיעות ארצה. היבואנית אז, חברת "ארץ ישראל". היבואנית היום: חברת מאיר
@
1951
@
נחנך מפעל קייזר-אילין בחיפה שהרכיב את קייזר מנהטן היוקרתית, הנרי ג'י הזולה ואת וויליס אירו. המכונית הראשונה הועברה לדוד בן גוריון, מרבית האחרות יוצאו לחו"ל, בין השאר ליוון ובפינלנד
@
1952
@
קייזר אילין מתחיל להרכיב – בקצב של יותר מ-1,000 בשנה - ולשווק ג'יפ CJ3 למוסדות, מפעלים ויישובי ספר, אך בעיקר לייצוא. משרד הביטחון רוכש  לצה"ל ג'יפים משומשים בארה"ב אבל אחרי שנתיים עובר ל-5CJ חדש שהורכב כאן. וגם, בפתח תקווה נפתחים שני מפעלי צמיגים ישראלים, אליאנס ושמשון.
@
1953
@
מתחילים להרכיב טנדר (618 לירות) וסטיישנים (729 לירות) של וויליס בחיפה, לשוק מקומי וייצוא. כ-1,000 מורכבים כבר בשנה הראשונה
@
1955
@
רנו תוצרת ישראל: קייזר-פרייזר מפסיקה לייצר מכוניות נוסעים וקייזר-אילין מתחיל להרכיב קאטר שבו, פרגונט ודופין שהופכת לסמל סטטוס. ב-59' תיכנע רנו לחרם הערבי ותפסיק את הפעילות.
@
1957
@
האוקטן המירבי בתחנות הדלק עולה מ-70 ל-83 אבל המכוניות האמריקאיות הנפוצות דרשו אוקטן 87. התוצאה: "צלצולים", פגיעה בביצועים ומנועים ששבקו
@
1958
@
לוחיות הרישוי עוברות לפורמט חמש ספרות. ב-61' תתווסף ספרה נוספת 
@
1959
@
מפעל האופניים של קיבוץ צרעה מתחיל להרכיב את ICM, טוסטוס עברי ראשון בשם טילון עם מנוע 49 סמ"ק של זאקס הגרמנית ושני הילוכים ידניים ואופציה לאוטומט בהמשך. 15 אלף ירדו מפס הייצור עד סגירת המפעל באמצע שנות ה-70 
@
1960
@
קייזר-אילין מתחילים להרכיב סטודיבייקר לארק עם שישה צילינדרים, רכב שרד נפוץ בקרב פקידי ממשלה וקצינים בכירים. המחיר: 18.5 אלף לירות. שש שנים מאוחר יותר הופסקה ההרכבה
@
1961
@
מכונית ספורט ישראלית ראשונה (ואחרונה) עולה על הכביש: אוטוקרס סברה. לרודסטר היה מנוע פורד 1.7 ליטר ופנסים אחוריים של אלפא רומיאו. 379 יחידות נבנו, 100 מהן בבריטניה 
@
1962
@
חברת רסקו ויבואנית פיאט יוצאות במבצע משותף: 25 אלף לירות עבור דירת 3 חדרים ברעננה ופיאט 500 חדשה עם משכנתא אפשרית של 9,000 לירות
@
1965
@
שנת השיא של סוסיתא: 2,532 סוסיתא "קובייה" מיוצרות באוטוקרס, רובן מסחריות סגורות עם מנוע ליטר של פורד. 525 ישראלים בוחרים בגרסת טנדר-פתוח, 436 בסטיישן
@
1966
ועכשיו גם משפחתית. הגלבוע היא מכונית ארבע דלתות ראשונה לסוסיתא, עם מנוע פורד בנפח 1.2 או 1.5 ליטר. רק 10 מכוניות נמכרו בגלל איכות ייצור ברצפה ומחיר בשמיים
@
1967
@
קייזר-אילין משיק מוצר חדש ואחרון: טנדר הינו בריסקה עם מנוע 1.3 ליטר. באותה שנה נרכשת הינו על-ידי טויוטה, שנכנעה לחרם הערבי והפסיקה את הייצוא לישראל. שנה אחר כך נמכר קייזר-אילין לאוטוקרס תמורת 3 מיליון דולר
@
1968
@
פולקסווגן חיפושית מגיעה ארצה באמצעות יבואנית חדשה: צ'מפיון מוטורס. לפני כן יובאה רק בייבוא אישי בשל הרגישות הרבה באותן שנים למכוניות גרמניות. בעניין אחר: בית המשפט העליון קובע כי חוק סגירת עסקים בשבת אינו חל על תחנות דלק    
@
1970
מירוץ מכוניות ראשון בישראל: בנובמבר נערך באשקלון גרנד-פרי ישראל. מירוץ מכוניות פורמולה-2 שהגיעו מאירופה, עם מקצה לנהגים ישראלים. הפגנת חרדים דוחה את האירוע משבת לראשון, ופריצת קהל למסלול כבר בתחילתו מביאה לסיומו המידי מטעמי בטיחות
@
1971
@
יוסף דוראל ממציא את כרטיס החנייה הנתלש, ומעכב בעשרות שנים את השתלטות המדחנים על הרחובות
@
1972
@
סובארו צוברת תאוצה ואלפי לקוחות מתלוננים על המתנה של חודשים למכונית חדשה שהזמינו מ"יפנאוטו". קצב המכירות מזנק מ-74 מכוניות ב-69' ל-2,600 ב-72'
@
1975
חובת שימוש בחגורות בטיחות ברכב. בינתיים רק במושבים קדמיים ובנסיעות בין עירוניות
@
1976
@
מכונית ישראלית אחרונה מושקת על-ידי רום כרמל, הגלגול החדש של אוטוקרס. רום 1300 משווקת כארבע דלתות או סטיישן עם מנועי פורד ומספק אותן לסא"לים
@
1977
@
המהירות המרבית המותרת עולה מ-80 ל-90 קמ"ש בחלק מהכבישים המוגדרים כמהירים. באירופה מותר כבר לנסוע 120 קמ"ש
@
1978
@
מותג הרכב הרומני דאצי'ה מגיע ארצה (ויגיע שוב ושוב בעתיד). שנה מאוחר יותר הוא יסתלק מהמפה המקומית עקב בעיות איכות מביכות שהתפרסמו בכלבוטק
@
1982
@
חברת נתיבי איילון שהוקמה ב-70' פותחת לתנועה קטע ראשון בכביש, בין מחלף השלום להלכה. ב-91' ייפתח הקטע המרכזי בין רוקח לגלילות. וגם, דייהטסו היא יצרנית יפנית שנייה אחרי סובארו לשווק בישראל (שרייד ושרמנט) ודאצי'ה טייק2 נוחתת כאן תחת השם "גאלידי". אחרי מספר מכוניות היא שוב נעלמת
@
1983
@
סוזוקי מגיעה לישראל עם האלטו, סמוראי וקארי המסחרית. שר התחבורה לחמש השנים הבאות הוא חיים קורפו שנכנס להיסטוריה בזכות אמירה מביכה אלמותית לפיה לא צריך חגורת בטיחות "ומספיק לתת קונטרה בהגה"
@
1984 
@
עקב המשבר הכלכלי אוסרת הממשלה למשך חצי שנה ייבוא של מוצרי מותרות, בהם מכוניות חדשות. האיסור לא נאכף והמכירות המשיכו כרגיל
@
1988
@
דאצ'יה שוב מגיעה לישראל עם הסלוגן הבלתי-נשכח "גם אתה יכול 88". מי שהשתכנע לא הפסיק לקלל את הרגע. ירחון אופנועים ישראלי נולד תחת השם "מוטו"
@
1989
מיצובישי מגיעה לישראל באמצעות כלמוטור. הדגמים: לאנסר, גלאנט, L300 מסחרי והסיסמה שתפסה "ויש בה הכל"
@
1990
@
הונדה נכנסת לישראל באמצעות חברת מאיר, בתחילה רק דגמים שמיוצרים בארה"ב מחשש לתגובות במדינות ערב. דאצ'יה מגיעה בפעם הרביעית על-ידי "מוטוקארס" ומשווקת כאן לזמן ממש קצר גרסאות סטיישן וטנדר תחת השם "שיפטר"
@
1991
@
החרם הערבי נשבר וטויוטה הגדולה מגיעה עם קורולה, קרינה והיילקס באמצעות יבואנית חדשה: יוניון מוטורס 
@
1992
@
עכשיו גם מאזדה מצטרפת. מי שתהפוך לנמכרת בישראל במשך 15 שנה נוחתת לראשונה עם 323 משפחתית, 626 גדולה וקסדוס מפוארת. ג'יפ סופה ראשון - מבוסס על רנגלר (YJ) הוותיק - יורד מפס הייצור בתעשיות רכב נצרת
@
1993
@
המהירות המרבית המותרת בישראל עולה ל-100 קמ"ש בכבישים חיפה-חדרה, ת"א-שער הגיא ואשדוד-ראשל"צ. מותג FSO העתיק מצטרף לשוק המקומי עם הפולונז (פיאט 125 עתיקה) שמבוססת על פיאט 1500 משנות ה-50. הביקור היה קצר
@
1995
@
יגואר מגיעה לישראל באמצעות מכשירי תנועה, אחר כך תשווק על-ידי מאיר וב-2017 תעבור לחברת המזרח. שיא המכירות (2017): 112 מכוניות בשנה
@
1996
@
פורשה מגיעה לישראל. GT3 911 סופר-ספורטיבית עולה 1.5 מיליון שקל, בוקסטר 490 אלף שקל. כבר בשנה הראשונה נמכרות 15 מכוניות. וגם, אביב קדשאי ממרחביה הוא ישראלי ראשון לסיים את המירוץ המפרך פאריז-דקאר, ועוד על אופנוע
@
1997
@
יורם זרחי מתחיל לייצר רכב שטח ישראלי מקורי שהקדים את זמנו: תומקאר TM2, טרקטורון שטח שבו יושבים נהג ונוסע זה לצד זה  
@
1999
@
פרופסור אמנון שעשוע ואיש העסקים זיו אבירם מקימים את מובילאיי, במטרה לפתח מערכת מצלמה דיגיטלית שתזהה מצבי חירום בכביש ותזהיר את הנהג
@
2002
@
לקראת סוף השנה מתמנה שר תחבורה חדש: צחי הנגבי. הוא יחזיק מעמד שלושה חודשים מבלי לתרום מאום
@
2004
@
שתי מכוניות היברידיות ראשונות הגיעו אלינו, שנים ארוכות לאחר שהחלו להימכר בחו"ל - טויוטה פריוס שתהפוך להיברידית הנמכרת בעולם (ובישראל) והונדה סיוויק IMA הפחות זכורה
@
2007
@
שי אגסי ועידן עופר מקימים את בטר פלייס, משווקת רכב חשמלי (של רנו) וספקית סוללות מתחלפות באמצעות תחנות ייעודיות
@
2008
@
ריקול מקומי עצום למכונית הנמכרת במדינה: 50 אלף מאזדה 3 מוזמנות למוסך עקב חשש מכיבוי מנוע תוך כדי נסיעה כתוצאה מקצר
@
2009
@
סינית ראשונה בישראל: חברת דוד לובינסקי (פיז'ו-סיטרואן) זכתה ב-SAIC הסינית ומתחילה לשווק את דגמי MG בארץ. הראשונה: משפחתית גדולה בשם MG550
@
2011
@
טל שביט, מייסד ירחון האופנועים הישראלי מוטו, מבכירי עיתונאי הרכב וכתב הרכב הדו-גלגלי של ynet נהרג בתאונת דרכים כשהוא רוכב על אופנוע. הפוגע: רכב שחנה על השוליים וחצה במפתיע שני נתיבים
@
2012
@
פרארי ומזראטי מגיעות לישראל. קליפורניה הזולה ביותר נמכרת ב-1.6 מיליון שקל. בשנה הראשונה יימכרו 12 מכוניות פרארי ו-17 מזראטי
@
2013
@
שש שנים לאחר שהוקמה מגישה בטר פלייס בקשה לפשיטת רגל. עידן עופר הפסיק לממן, המנכ"ל שי אגסי מתפטר. 33 תחנות החלפת סוללות שהוקמו הפכו מיותמות. 1,000 מכוניות נמכרו, 3 מיליארד שקלים הושקעו. נכסי החברה נמכרו תמורת 43 מיליון שקל
@
2014
@
שנה לאחר ששר התחבורה ישראל כץ הכריז על העלאת המהירות המותרת בכביש 6 ל-120 קמ"ש נגד חוות דעת המשטרה, עולה המהירות המותרת בפועל בקטע המרכזי של כביש 6, בין מחלף עירון בצפון למחלף חדיד שבמרכז בארץ
@
2015
@
דאצ'יה שנרכשה על-ידי ניסאן-רנו חוזרת בפעם החמישית לישראל, הפעם תחת כנפי היבואנית הוותיקה קרסו
@
2016
@
לראשונה מותרת רכיבת דו-גלגלי בנתיבי תחבורה ציבורית בתל אביב. הצלחתו של הפיילוט תגרור אישור לכל גוש דן. וגם, שיא מכירת רכב חדש נשבר - 286 אלף מכוניות עלו על הכביש במהלך השנה
@
2017
@
סוף לייצור המכוניות בישראל: ביוני יורדים מפס הייצור במפעל תעשיות רכב נצרת אחרוני דגמי  הסופה-4 המיועדים לצה"ל, לאחר 65 שנות הרכבה רצופות של ג'יפ בארץ
`


// WEBPACK FOOTER //
// ./src/data/timeline_data.js